// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1838":"8a26378c","3880":"0e0226d4","5618":"0e0226d4"}[chunkId] + ".chunk.css";
};